import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives';
import { CrsSearchModule } from '../crs-search';
import { JobSiteEditComponent } from './job-site-edit.component';

@NgModule({
    declarations: [JobSiteEditComponent],
    imports: [CommonModule, TwcModule, TranslateModule, FormsModule, ReactiveFormsModule, CrsSearchModule, DirectivesModule],
    exports: [JobSiteEditComponent],
})
export class JobSiteEditModule {}
